import { MenuInterface } from '../../../entities';

export const HeaderMenus: { globalMenu: MenuInterface[]; primary: MenuInterface[]; secondary: MenuInterface[] } = {
  globalMenu: [],
  primary: [
    {
      href: 'https://fr.benzinga.com/news/france/',
      label: 'Actualités France',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://fr.benzinga.com/news/france/stocks/', label: 'Bourse', title: 'Bourse' },
          { href: 'https://fr.benzinga.com/news/france/indices/', label: 'Indices', title: 'Indices' },
          { href: 'https://fr.benzinga.com/news/france/bonds/', label: 'Obligations', title: 'Obligations' },
          { href: 'https://fr.benzinga.com/news/france/etfs/', label: 'ETFs', title: 'ETFs' },
          { href: 'https://fr.benzinga.com/news/france/economy/', label: 'Economie', title: 'Economie' },
          { href: 'https://fr.benzinga.com/news/france/general/', label: 'Général', title: 'Général' },
        ],
      },
      title: '',
      width: '57px',
    },
    {
      href: 'https://fr.benzinga.com/news/usa/',
      label: 'Actualités Américaines',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://fr.benzinga.com/news/usa/stocks/',
            label: 'Bourse',
            title: 'Bourse',
          },
          {
            href: 'https://fr.benzinga.com/news/usa/indices/',
            label: 'Indices',
            title: 'Indices',
          },
          // {
          //   href: 'https://fr.benzinga.com/news/usa/earnings/',
          //   label: 'Ganancias',
          //   title: 'Ganancias',
          // },
          {
            href: 'https://fr.benzinga.com/news/usa/earnings/',
            label: 'Bénéfices',
            title: 'Bénéfices',
          },
          {
            href: 'https://fr.benzinga.com/news/usa/economy/',
            label: 'Economie',
            title: 'Economie',
          },
          {
            href: 'https://fr.benzinga.com/news/usa/othermarkets/',
            label: 'Autres marchés',
            title: 'Autres marchés',
          },
          {
            href: 'https://fr.benzinga.com/news/usa/analystratings/',
            label: 'Recommandations des analystes',
            title: 'Recommandations des analystes',
          },
          {
            href: 'https://fr.benzinga.com/news/usa/trading/',
            label: 'Trading',
            title: 'Trading',
          },
          {
            href: 'https://fr.benzinga.com/actualites/communiques-de-presse/',
            label: 'Communiqués de presse',
            title: 'Communiqués de presse',
          },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://fr.benzinga.com/news/global/',
      label: 'Mondial',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://fr.benzinga.com/news/global/asia/',
            label: 'Asie',
            title: 'Asie',
          },
          {
            href: 'https://fr.benzinga.com/news/global/europe/',
            label: 'Europe',
            title: 'Europe ',
          },
        ],
      },
      // title: '글로벌 뉴스',
      // width: '57px',
    },
    {
      href: 'https://fr.benzinga.com/crypto/',
      label: 'Crypto-monnaies',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://fr.benzinga.com/crypto/news/',
            label: 'Actualités cryptos',
            title: 'Actualités cryptos',
          },
          {
            href: 'https://fr.benzinga.com/crypto/altcoins/',
            label: 'Altcoins',
            title: 'Altcoins',
          },
          {
            href: 'https://fr.benzinga.com/crypto/bitcoin/',
            label: 'Bitcoin',
            title: 'Bitcoin',
          },
          {
            href: 'https://fr.benzinga.com/crypto/blockchain/',
            label: 'Blockchain',
            title: 'Blockchain',
          },
          {
            href: 'https://fr.benzinga.com/crypto/dogecoin/',
            label: 'Dogecoin',
            title: 'Dogecoin',
          },
          {
            href: 'https://fr.benzinga.com/crypto/ethereum/',
            label: 'Ethereum',
            title: 'Ethereum',
          },
          {
            href: 'https://fr.benzinga.com/crypto/shiba-inu/',
            label: 'Shiba Inu',
            title: 'Shiba Inu',
          },

          {
            href: 'https://fr.benzinga.com/crypto/nfts/',
            label: 'NFT',
            title: 'NFT',
          },
        ],
      },
      // title: '암호화폐',
      // width: '57px',
    },
    {
      href: 'https://fr.benzinga.com/education/',
      label: 'Éducation',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://fr.benzinga.com/education/crypto/',
            label: 'Investir en crypto',
            title: 'Investir en crypto',
          },
          {
            href: 'https://fr.benzinga.com/education/stocks/',
            label: 'Investir en bourse',
            title: 'Investir en bourse',
          },
          {
            href: 'https://fr.benzinga.com/education/forex/',
            label: 'Forex',
            title: 'Forex',
          },
        ],
      },
      // title: '교육 센터',
      // width: '57px',
    },
  ],
  secondary: [],
};
